<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-button
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-4 self-end"
        size="small"
        @click="$refs.dialogCreate.toggleActive(true)"
      >Tambah Jabatan Baru</vs-button>
      <h3>Manajemen Data Jabatan</h3> <br>
      <div class="w-full flex justify-end">
        <div>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            placeholder="Cari"
            v-model="search"
          />
        </div>
      </div>
      <global-wrapper
        :loading="$apollo.queries.jabatan.loading"
        :loadingType="'TwoLine'"
        :loadingList="5"
        :empty="jabatan.data.length == 0"
        :error="error"
      >
        <global-table 
          @reloadData="handleOnReloadPage($event)" 
          :currentPage="paginationPage" 
          :totalPage="jabatan.paginatorInfo.lastPage"
        >
          <template #thead>
            <global-th widglobal-th="20px" left="0" class="sticky-col"
              >No.</global-th>
            <global-th>Nama Jabatan</global-th>
            <global-th>Action</global-th>
          </template>
          <template #tbody>
            <global-tr v-for="(item, index) in jabatan.data" :key="index">
              <global-td width="20px" left="0" class="sticky-col">
                {{ Math.ceil((jabatan.paginatorInfo.currentPage-1) * jabatan.paginatorInfo.perPage + index + 1) }}
              </global-td>
              <global-td>{{item.nama}}</global-td>
              <global-td>
                <div class="vx-row">
                  <vs-button
                    color="primary"
                    size="small"
                    class="m-1"
                    type="border"
                    icon-pack="feather"
                    icon="icon-eye"
                    @click="$router.push({name: 'jabatan-detail', params: {uuid: item.uuid}})"
                  >Detail</vs-button>
                  <vs-button
                    color="danger"
                    size="small"
                    class="m-1"
                    type="border"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="handleOnRemove(item.id)"
                  >Hapus</vs-button>
                </div>
              </global-td>
            </global-tr>
          </template>
        </global-table>
      </global-wrapper>
      <DialogCreate
        ref="dialogCreate"
        @submitCallback="refreshJabatanQuery()"
      />
    </div>
  </div>
</template>

<script>
import {GET_ALL as ALL_JABATAN} from '@/query/jabatan';
import {ALL as ALL_PENGGUNA} from '@/query/pengguna';
import {DELETE as DELETE_JABATAN} from '@/query/jabatan';
import vSelect from "vue-select";
import DialogCreate from "./DialogCreate";
import _ from "lodash";

export default {
  components : {
    "v-select": vSelect,
    DialogCreate
  },
  data() {
    return {
      jabatan: {
        data: [],
        paginatorInfo: {
          lastPage : 1,
          currentPage: 1
        }
      },
      error: false,
      paginationPage: 1,
      search: '',
    };
  },
  watch : {
    search: {
      handler(){
        this.refetchJabatanQuery();
      },
      deep: true
    }
  },
  apollo : {
    jabatan : {
      query : ALL_JABATAN,
      update: data => data.jabatan,
      variables(){
        return {
          perPage: 10,
          page: this.paginationPage,
          where: {column: "NAMA", operator: "LIKE", value: `%${this.search}%`}
        }
      },
      fetchPolicy: "network",
    },
  },
  methods : {
    async handleOnRemove(jabatanId){
      const responseCheck = await this.$apollo.query({
        query: ALL_PENGGUNA,
        variables: {
          perPage: 10,
          where: { column: "JABATAN_ID", value: jabatanId},
        }
      });
      console.log(responseCheck);
      if(responseCheck.data.pengguna.data.length != 0){
        this.$vs.notify({
          title: 'Jabatan ini tidak dapat dihapus karena terdapat relasi dengan data pengguna !',
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
          position : "top-right"
        });
      }
      else{
        this.deleteJabatan(jabatanId);
      }
    },
    deleteJabatan(jabatanId){
      this.$apollo.mutate({
        mutation: DELETE_JABATAN,
        variables: {
          id: jabatanId
        }
      })
      .then(() => {
        this.$vs.notify({
          title: 'Berhasil menghapus jabatan !',
          color: "warning",
          iconPack: "feather",
          icon: "icon-check",
          position : "top-right"
        });
        this.refreshJabatanQuery();
      })
      .catch(error => {
        console.error(error);
        this.$vs.notify({
          title: 'Terjadi kesalahan, silahkan hubungi tim IT !',
          color: "danger",
          iconPack: "feather",
          icon: "icon-x",
          position : "top-right"
        });
      });
    },
    refetchJabatanQuery: _.debounce(function() {
      this.refreshJabatanQuery();
    }, 300),
    refreshJabatanQuery() {
      this.$nextTick().then(() => {
        this.error = false;
        this.$apollo.queries.jabatan.refetch();
      });
    },
    handleOnReloadPage(event){
      this.paginationPage = event;
      this.refreshJabatanQuery();
    },
  },
};
</script>